var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.className, 'section'],attrs:{"id":_vm.id}},[_c('div',{staticClass:"section-wrapper"},[_c('div',{staticClass:"section-title"},[_c('h4',[_vm._v(_vm._s(_vm.title))]),(_vm.description)?_c('p',[_vm._v(_vm._s(_vm.description))]):_vm._e()]),_c('div',{staticClass:"section-body"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }